__webpack_require__.p = "/tokens-new-stage-badges/account-setup/";